<template>
    <div class="mt-2 pl-3">
        <template v-if="!startText">
            <CRow
                v-if="entities.length"
                form
                class="form-group">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">Сервис для копирования</CCol>
                <CCol sm="9">
                    <CSelect
                        class="mb-0"
                        inline
                        :options="entities"
                        placeholder="Выберите сервис..."
                        @update:value="chooseService"
                    />
                </CCol>
            </CRow>
            <CRow v-if="fromId" class="pl-3 pt-3 form-group">
                <CButton
                    color="primary"
                    @click="open = true"
                >Копировать</CButton>
            </CRow>
        </template>
        <template v-else>
            <CRow>Копирование запустилось.</CRow>
        </template>

        <CModal
            title="Подтверждение"
            color="primary"
            :show.sync="open"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>Вы уверены что хотите скопировать «<strong>{{ from }}</strong>» в «<strong>{{ to }}</strong>»?</p>
                    <p>Все товары и настройки «<strong>{{ to }}</strong>» будут <strong>удалены</strong> перед копированием!</p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="open = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="copy"
                    >Копировать</CButton>
                </div>
            </template>
        </CModal>
        
    </div>
</template>

<script>
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {
        props: {
            type: {
                type: String,
                default: '',
            },
            id: {
                type: Number,
                default: null,
            },
        },

        data: () => ({
            entities: [],
            fromId: null,
            from: '',
            to: '',
            open: false,
            startText: false,
        }),

        computed: {
            
        },

        async mounted() {
            if (!Object.values(BUSINESS_TYPE).includes(this.type)) {
                this.$root.$emit('showError', 'Тип бизнеса не найден.');
                return;
            }
            switch (this.type) {
            case BUSINESS_TYPE.RESTAURANT:
                await this.fetchRestaurants();
                break;
            default: return;
            }
        },

        methods: {
            async fetchRestaurants() {
                const { data } = await this.axios.get('/restaurants');
                this.entities = data
                    .map(rest => ({ value: rest.id, label: rest.title }))
                    .filter(rest => rest.value !== this.id);
                this.to = data?.find(entity => entity.id === this.id)?.title;
            },

            chooseService(val) {
                this.from = this.entities.find(entity => entity.value === val)?.label;
                this.fromId = val;
            },

            async copy() {
                this.open = false;
                this.startText = true;
                try {
                    await this.axios.post('/import/copy/', { type: this.type, from: this.fromId, to: this.id });
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка создания копии. ' + error);
                }
                this.startText = false;
            }
        }
    };
</script>
